import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import calculator from './modules/calculator'
import getters from './getter'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    calculator
  },
  getters
})

export default store
